// React
import React from 'react';

// Components
import { MpsButton } from '@mobilitystore/components-interface';
import LoanUserMenu from './loan-user-menu';

// Css
import './loan-header.scss';

// Self-contained header for /loans: logo on the left, Login/user-menu on the right.
// Built separately from the shared MinimalHeader since that component couldn't reliably
// place a right-side action alongside the logo.
const LoanHeader = ({
  logoImage,
  logoAlt,
  onLogoClick,
  isLoggedIn,
  onLoginClick,
  firstName,
  lastName,
  emailId,
  loginLabel,
  userMenuIconAriaLabel
}) => (
  <header className='loan-header'>
    <button
      type='button'
      className='loan-header__logo'
      onClick={onLogoClick}
      aria-label={logoAlt}
    >
      <img src={logoImage} alt={logoAlt} title={logoAlt} />
    </button>

    <div className='loan-header__actions'>
      {isLoggedIn ? (
        <LoanUserMenu
          firstName={firstName}
          lastName={lastName}
          emailId={emailId}
          iconAriaLabel={userMenuIconAriaLabel}
        />
      ) : (
        <MpsButton label={loginLabel} mode='primary' onClick={onLoginClick} />
      )}
    </div>
  </header>
);

export default LoanHeader;
